// extracted by mini-css-extract-plugin
export default {"textError":"TextError_textError__0mmQv"};